import React, {
  useReducer,
  createContext,
  useEffect,
  useState
} from "react";
import ReactDOM from "react-dom";
import App from "./containers/App";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/antd.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'semantic-ui-css/semantic.min.css'


import "./index.css";
import {
  Auth
} from "./config/firebase";
import Authenticate from "./Logic/Auth/Auth";

export const UserContext = createContext();

const Index = () => {
  const [user, setUser] = useState("");
  useEffect(() =>
    Auth.onAuthStateChanged(function (User) {
      if (User) {
        Authenticate.FindUser(User.uid).then(res =>
          setUser({
            ...User,
            role: res.role
          })
        );
      } else {
        setUser(false);
      }
    })
  );
  return ( <
    UserContext.Provider value = {
      user
    } >
    <
    App / >
    <
    /UserContext.Provider>
  );
};
const rootElement = document.getElementById("root");
ReactDOM.render( < Index / > , rootElement);